var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBuildmapActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_593",
    "data-name": "Group 593",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.866,
    height: 23.866,
    viewBox: "0 0 23.866 23.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 23.866,
    height: 23.866,
    fill: "#22c8bc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M11.709,23.866A.819.819,0,0,1,11.176,23c.016-.628,0-1.257.007-1.886,0-.179-.045-.248-.241-.275a8.872,8.872,0,0,1-7.094-5.058,8.032,8.032,0,0,1-.808-2.849c-.021-.2-.105-.238-.279-.236-.652.006-1.3,0-1.956,0a.762.762,0,1,1-.01-1.522c.66,0,1.32,0,1.979,0,.167,0,.239-.038.264-.227A8.875,8.875,0,0,1,8.105,3.843a8.038,8.038,0,0,1,2.85-.806c.19-.019.229-.1.227-.264-.006-.66,0-1.32,0-1.979A.762.762,0,1,1,12.7.8c0,.652,0,1.3,0,1.956,0,.174.033.253.236.28a8.869,8.869,0,0,1,7.107,5.074,8.069,8.069,0,0,1,.8,2.851c.018.177.088.219.248.218.636-.006,1.273.01,1.909-.006a.819.819,0,0,1,.863.533v.466a.818.818,0,0,1-.862.533c-.628-.016-1.257,0-1.886-.007-.179,0-.255.041-.275.24a8.049,8.049,0,0,1-.81,2.848,8.871,8.871,0,0,1-7.117,5.057c-.176.023-.218.09-.217.249.005.636-.01,1.273.006,1.909a.819.819,0,0,1-.533.862Zm7.659-11.927a7.422,7.422,0,1,0-7.431,7.417,7.419,7.419,0,0,0,7.431-7.417",
    transform: "translate(-0.001 0)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M136.583,132.1a4.492,4.492,0,1,1-4.464-4.5,4.5,4.5,0,0,1,4.464,4.5m-4.5-2.961a2.939,2.939,0,0,0-2.936,2.964,2.946,2.946,0,1,0,5.893-.02,2.94,2.94,0,0,0-2.956-2.945",
    transform: "translate(-120.154 -120.156)",
    fill: "#22c8bc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildmapActive);
export default __webpack_public_path__ + "static/media/icon_buildmap-active.ca40af401194aed433ddfb1be53f8b34.svg";
export { ForwardRef as ReactComponent };